import { render } from "./GoalBox.vue?vue&type=template&id=727f9921&scoped=true"
import script from "./GoalBox.vue?vue&type=script&lang=ts"
export * from "./GoalBox.vue?vue&type=script&lang=ts"

import "./GoalBox.vue?vue&type=style&index=0&id=727f9921&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-727f9921"

export default script